var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module",class:_vm.loading ? 'module--loading' : ''},[_c('div',{staticClass:"module__media bg-dark-pink"}),_vm._m(0),_c('div',{staticClass:"module__main"},[_c('fieldset',[_c('cludo-vue-input',{staticClass:"form-control form-control--search",attrs:{"placeholder":"Search..."}},[_c('span',{staticClass:"sr-only"},[_vm._v("Search")]),_c('i',{staticClass:"icon-search",attrs:{"aria-hidden":"true"}})])],1),_c('button',{staticClass:"button button--small button--block button--toggle toggle toggle--m",attrs:{"type":"button","aria-expanded":"false","aria-controls":"search-filters","data-toggle":"true"}},[_vm._v(" Filter courses "),(_vm.isFiltering)?_c('span',{staticClass:"badge bg-white"},[_vm._v(_vm._s(_vm.filtersCount))]):_vm._e()]),_c('div',{staticClass:"collapse collapse--tablet-expanded",attrs:{"id":"search-filters"}},[_c('div',{staticClass:"collapse__content"},[_c('cludo-vue-check-boxes',{attrs:{"options":[
            {
              label: 'Full-time study',
              name: 'full-time',
              field: 'StudyModes',
              value:
                'full-time only, full-time with part-time study available',
            },
            {
              label: 'Part-time study',
              name: 'part-time',
              field: 'StudyModes',
              value:
                'part-time only, full-time with part-time study available',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Study type")])])]),_c('cludo-vue-check-boxes',{attrs:{"options":[
            {
              label: 'Study or work abroad',
              name: 'year-abroad',
              field: 'StudyOptions',
              value:
                'year_aboard, year_industry with year_aboard, year_aboard with open_international, year_industry with year_aboard with open_international',
            },
            {
              label: 'Year in industry',
              name: 'year-industry',
              field: 'StudyOptions',
              value:
                'year_industry, year_industry with year_aboard, year_industry with open_international, year_industry with year_aboard with open_international',
            },
            {
              label: 'Open to international students',
              name: 'open-international',
              field: 'StudyOptions',
              value:
                'open_international, year_aboard with open_international, year_industry with open_international, year_industry with year_aboard with open_international',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Study options")])])])],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module__header"},[_c('h2',[_vm._v("Search by course name or keyword")])])
}]

export { render, staticRenderFns }